module.exports = __webpack_public_path__ + "img/grade21.ab51183f.png";